import React from 'react';
import { useIntl } from 'react-intl';

import JourneyLayout from '../../modules/journeys/JourneyLayout/JourneyLayout';
import messages from './messages';
import { LocationIcon } from '../../components/icons';
import ContactDataForm from '../../modules/journeys/forms/ContactDataForm/ContactDataForm';

const JourneyContactDataPage = () => {
  const { formatMessage } = useIntl();

  return (
    <JourneyLayout
      step="contact"
      heading={formatMessage(messages.stepTwo_title)}
      text=""
      icon={<LocationIcon />}
    >
      <ContactDataForm />
    </JourneyLayout>
  );
};

export default JourneyContactDataPage;
